var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import HeaderLogoTextStyle from './HeaderLogoTextStyle';
import HeaderTitle from './HeaderTitle';
const HeaderLogoText = (_a) => {
    var { title, homeLink, tall, logo: LogoIcon } = _a, otherProps = __rest(_a, ["title", "homeLink", "tall", "logo"]);
    return (React.createElement(HeaderLogoTextStyle, Object.assign({}, otherProps),
        LogoIcon && React.createElement(LogoIcon, { href: homeLink, title: title, tall: tall }),
        title && React.createElement(HeaderTitle, { href: homeLink }, title)));
};
export default HeaderLogoText;
//# sourceMappingURL=HeaderLogoText.js.map